import React from 'react'
import { Row, Col, Form } from 'antd'
import { Input, Select, DatePicker } from 'ui/styled'
import { Label } from 'pages/Ticket/styled'
import { DATE_FORMAT_YMD } from 'utils/helpers/dateHelper'
import {
  requestorOptions,
  engineeringStatusOptions
} from 'constants/enumCollections/GroupTermingTypes'

const { Item } = Form

const GroupTermingFields = () => (
  <>
    <Row>
      <Col span={11}>
        <Label required>Client Name</Label>
        <Item
          name="client_name"
          rules={[
            {
              required: true,
              message: 'Please input client name'
            }
          ]}
        >
          <Input />
        </Item>
      </Col>
      <Col span={11} offset={1}>
        <Label required>Term date</Label>
        <Item
          name="term_date"
          rules={[
            {
              required: true,
              message: 'Please select term date'
            }
          ]}
        >
          <DatePicker format={DATE_FORMAT_YMD} placeholder="Select Date" />
        </Item>
      </Col>
    </Row>
    <Row>
      <Col span={11}>
        <Label required>Run Out date</Label>
        <Item
          name="run_out_date"
          rules={[
            {
              required: true,
              message: 'Please select run out date'
            }
          ]}
        >
          <DatePicker format={DATE_FORMAT_YMD} placeholder="Select Date" />
        </Item>
      </Col>
      <Col span={11} offset={1}>
        <Label required>Requestor</Label>
        <Item
          name="requestor"
          rules={[
            {
              required: true,
              message: 'Please choose requestor type'
            }
          ]}
        >
          <Select options={requestorOptions} />
        </Item>
      </Col>
    </Row>
    <Row>
      <Col span={11}>
        <Label>Termination Reason</Label>
        <Item name="termination_reason">
          <Input />
        </Item>
      </Col>
      <Col span={11} offset={1}>
        <Label>Special Instructions</Label>
        <Item name="special_instruction">
          <Input />
        </Item>
      </Col>
    </Row>
    <Label>JIRA Ticket Link</Label>
    <Row>
      <Col span={22}>
        <Item name="jira_ticket_link">
          <Input />
        </Item>
      </Col>
    </Row>
    <Row>
      <Col span={11}>
        <Label>Engineering Status</Label>
        <Item name="engineering_status">
          <Select
            options={engineeringStatusOptions}
            placeholder="Engineering Status"
          />
        </Item>
      </Col>
    </Row>
  </>
)

export default GroupTermingFields
